import { styled, theme } from 'ui/theme';

export const Payment = {
  Component: styled('div')`
    align-items: center;
    display: flex;
  `,

  Description: styled('div')`
    font-size: ${theme.fontSizes.sm};
  `,

  IconWrapper: styled('div')`
    color: ${theme.colors.build.mediumLight1};
    margin-right: ${theme.sizes[2]};
  `,

  Info: styled('div')`
    color: ${theme.colors.build.mediumLight1};
  `,

  Title: styled('div')`
    font-size: ${theme.fontSizes.md};
  `,
};
